/**
 * Tutoriel — le PARCOURS GUIDÉ (N32.6, plan validé le 29-09-2026), sur la maquette « Parcours d'un ticket »
 * (v2 du 24-09). Une carte à la fois, six phases, et un contenu qui vit EN BASE : les admins corrigent chaque
 * carte à l'écran (décision C3 du 24-09). Ce fichier porte ce que l'API et l'écran doivent lire pareil :
 * les listes de valeurs permises et la forme d'une carte.
 *
 * Ce que la maquette codait en dur (le code de livraison qui choisit la suite, les cinq issues du scope, les
 * suggestions de cadran) est devenu de la DONNÉE : chaque réponse peut porter une « correspondance »
 * (`TutorialAnswerMatch`) — un admin la corrige comme le reste, sans déploiement.
 */
/** Les six phases du parcours, dans l'ordre. La colonne `category` d'un nœud porte l'une d'elles. */
export const TUTORIAL_PHASES = ['lire', 'identifier', 'verifier', 'capacite', 'agir', 'terminer'];
/** Le type d'une carte dit comment elle s'affiche :
 *  question → ses réponses en gros boutons · info → des points, puis « suivant » · action → des étapes numérotées,
 *  puis « suivant » · end → fin de parcours (« Ticket suivant ») · code → le code de livraison saisi et décodé ·
 *  scope → trois cases (V2, V1.5, out of scope) · window → l'aperçu d'une fenêtre de l'application ·
 *  rules → hors parcours : le contenu de la fenêtre « Règles de capacité ». */
export const TUTORIAL_CARD_KINDS = ['question', 'info', 'action', 'end', 'code', 'scope', 'window', 'rules'];
/** Les marques d'une carte : à définir (aucune règle écrite) · à trancher (deux sources se contredisent) ·
 *  retour de réunion · décidé mais pas encore dans l'application. */
export const TUTORIAL_TAGS = ['todo', 'decide', 'meeting', 'future'];
export const TUTORIAL_CALLOUT_TYPES = ['todo', 'decide', 'warn', 'ok'];
/** Le groupe d'un code de livraison, tel que la carte « code » le décode : Homes Passed · pas encore Homes Passed
 *  (composé en …1 à …4, ou série plate 1101-1103) · Homes Connect · code de blocage · aucun code. */
export const TUTORIAL_CODE_GROUPS = ['HP_HCA', 'NOT_HP', 'HC', 'BLOCKED', 'NONE'];
/** L'issue des trois cases de la carte « scope » : les deux listes · Build list seule · Deployment list seule ·
 *  aucune · retirée (la date « out of scope » l'emporte sur les deux autres). */
export const TUTORIAL_SCOPE_OUTCOMES = ['both', 'v2', 'v15', 'none', 'oos'];
/** Une carte vide, valeurs par défaut comprises — ce que la lecture rend pour un nœud sans contenu. */
export function emptyTutorialCard() {
    return {
        short: null, kind: 'question', tags: [], lead: null, points: [], steps: [], callouts: [],
        more: null, moreLabel: null, checklist: [], checklistHint: null, examples: [], window: null,
        next: null, distanceHelper: false, factLabel: null, skipWhenCodeDecides: false,
    };
}
export const isTutorialPhase = (v) => typeof v === 'string' && TUTORIAL_PHASES.includes(v);
//# sourceMappingURL=tutorial.js.map